module.exports = __webpack_public_path__ + "img/banner_dummy_paragliding.3645c5dc.png";